// extracted by mini-css-extract-plugin
export default {"wrapper":"app_wrapper__WftjS","content":"app_content__1Nnb+"};